import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getWarningIssues, getErrorIssues } from '../../../../../../../utils/validationSummary';
import { Checkbox } from '@material-ui/core';

class PropertyPickerVertical extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            value: !isNaN(this.props.property.value) ? this.props.property.value : this.props.property.valueMeta.default,
            isChecked: this.isActive()
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeCheckBox = this.handleChangeCheckBox.bind(this);
    }

    isActive() {
        return this.props.property.value !== 'Off' && this.props.property.value !== this.props.property.valueMeta.off;
    }

    handleChange(e) {
        if (e.target.value === null || e.target.value === undefined || e.target.value === '') {
            return;
        }
        const value = this.props.type === null || this.props.type === undefined || this.props.type === 'int'
                            ? ( this.props.property.valueMeta.min >= 0
                                    ? e.target.value.replace(/[^0-9]/g, '')
                                    : e.target.value.replace(/[^0-9|-]/g, ''))
                            : e.target.value;
        this.setState({
            value: value
        });

        this.props.handleChange(this.props.property.info.name, value);
    }

    handleChangeCheckBox(e) {
        const value = e.target.checked;
        this.setState({ isChecked: value });

        if (value) {
            this.props.handleChange(this.props.property.info.name, this.props.property.valueMeta.initial !== null ? this.props.property.valueMeta.initial : this.props.property.valueMeta.default);
        } else {
            this.props.handleChange(this.props.property.info.name, this.props.property.valueMeta.off);
        }

    }

    componentDidUpdate(prevProps) {
        if (this.props.property.value !== prevProps.property.value
                || (!isNaN(this.props.property.value) && (this.props.property.value+'') !== (this.state.value+''))
                || (isNaN(this.props.property.value) && (this.props.property.valueMeta.default+'') !== (this.state.value+''))) {
            this.setState({
                value: !isNaN(this.props.property.value) ? this.props.property.value : this.props.property.valueMeta.default,
                isChecked: this.isActive(),
            });
        }
    }

    render() {

        const errors = getErrorIssues(this.props.issues, this.props.property);
        const warnings = getWarningIssues(this.props.issues, this.props.property);

        const className = `input-property-picker ${errors.length > 0 ? 'danger' : warnings.length > 0 ? 'warning' : ''}`;

        let issuesComponent = null;
        if (errors.length > 0) {
            issuesComponent = (
                <div className="error-text">
                    {errors.map(issue => issue.description)}
                </div>
            );
        } else {
            issuesComponent = (
                <div className="warning-text">
                    {warnings.map(issue => issue.description)}
                </div>
            );
        }

        const checkBoxElem = this.props.checkbox
            ? (<Checkbox
                disabled={this.props.disabled}
                checked={this.state.isChecked}
                style={{ paddingTop: '0', paddingBottom: '0' }}
                onChange={this.handleChangeCheckBox} />)
            : null;

        const style = {
            width: 'fit-content', 
            float: 'left',
        };

        if (this.props.border?.indexOf("left") >= 0) {
            style.borderLeft = "1px solid rgba(0,0,0,.125)";
        }
        if (this.props.border?.indexOf("right") >= 0) {
            style.borderRight = "1px solid rgba(0,0,0,.125)";
        }

        return (
            <Col className={this.props.border ? this.props.border + " card-body-feature-col" : "card-body-feature-col"} style={style}>
                <Row style={{ fontWeight: "500", flexWrap: "nowrap" }}>
                    {checkBoxElem}
                    {this.props.title}
                </Row>

                <Row style={{ width: "auto", paddingBottom: "0" }}>
                    <input
                        disabled={this.props.disabled || (this.props.checkbox && !this.isActive())}
                        className={className}
                        name={this.props.property.info.name}
                        type="number"
                        min={this.props.min}
                        max={this.props.max}
                        step={this.props.step}
                        value={this.props.checkbox && !this.isActive() ? '' : this.state.value}
                        onChange={this.handleChange} />
                </Row>
                <Row className="unit-measure-current-setting">
                    {this.props.measureUnit}
                </Row>
                <Row>
                    {issuesComponent}
                </Row>
            </Col>
        );
    };
}

const mapStateToProps = (state, ownProps) => {
    return {
        issues: state.ledmodule.issueByProperty,
    };
};

const mapDispatchToProps = {
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PropertyPickerVertical);